const SET_DANH_SACH_VAN_BAN_DI = (state, danhSachVanBanDi) => {
  state.danhSachVanBanDi = danhSachVanBanDi;
};

const SET_SO_LUONG_VAN_BAN_DI = (state, soLuongVanBanDi) => {
  state.soLuongVanBanDi = soLuongVanBanDi;
};

const SET_CHI_TIET_VAN_BAN_DI = (state, chiTietVanBanDi) => {
  state.chiTietVanBanDi = chiTietVanBanDi;
};

const SET_VAN_BAN_DEN_VAN_BAN_DI = (state, vanBanDenVanBanDi) => {
  state.vanBanDenVanBanDi = vanBanDenVanBanDi;
};

const SET_MULTI_VAN_BAN_DEN = (state, multiVanBanDen) => {
  state.multiVanBanDen = multiVanBanDen;
};

const SET_DOWNLOAD_FILE_DINH_KEM = (state, multiVanBanDen) => {
  state.downloadFileDinhKem = multiVanBanDen;
};

const SET_LIST_XIN_SO = (state, listXinSo) => {
  state.listXinSo = listXinSo;
};

const SET_DANH_SACH_NGUOI_DUOC_TRA_LAI = (state, danhSachNguoiDuocTraLai) => {
  state.danhSachNguoiDuocTraLai = danhSachNguoiDuocTraLai;
};

const SET_DON_VI_DA_BAN_HANH = (state, donViDaBanHanh) => {
  state.donViDaBanHanh = donViDaBanHanh;
};

const SET_LS_CAP_NHAT = (state, lichSuCapNhat) => {
  state.lichSuCapNhat = lichSuCapNhat;
};

const SET_LS_TRA_LAI = (state, lichSuTraLai) => {
  state.lichSuTraLai = lichSuTraLai;
};

const SET_LS_THU_HOI = (state, lichSuThuHoi) => {
  state.lichSuThuHoi = lichSuThuHoi;
};

const SET_LS_HUY_DUYET = (state, lichSuHuyDuyet) => {
  state.lichSuHuyDuyet = lichSuHuyDuyet;
};

const SET_LUONG_XU_LY = (state, luongXuLy) => {
  state.luongXuLy = luongXuLy;
};

const SET_LICH_SU_KY_DUYET = (state, lichSuKyDuyet) => {
  state.lichSuKyDuyet = lichSuKyDuyet;
};
const SET_LICH_SU_THEO_DOI_LIEN_THONG = (state, lichSuTheoDoiLienThong) => {
  state.lichSuTheoDoiLienThong = lichSuTheoDoiLienThong;
};
const SET_CON_VI_NGANG_CAP = (state, donViNgangCap) => {
  state.donViNgangCap = donViNgangCap;
};

const SET_NGUOI_XU_LY_TIEP_THEO = (state, nguoiXuLyTiepTheo) => {
  state.nguoiXuLyTiepTheo = nguoiXuLyTiepTheo;
};

const SET_LICH_SU_THEO_DOI_VB = (state, lichSuTheoDoiVB) => {
  state.lichSuTheoDoiVB = lichSuTheoDoiVB;
};

const SET_DV_DA_BAN_HANH = (state, dvDaBanHanh) => {
  state.dvDaBanHanh = dvDaBanHanh;
};

const SET_DANH_SACH_MULTI_VAN_BAN_DI = (state, danhSachMultiVanBanDi) => {
  state.danhSachMultiVanBanDi = danhSachMultiVanBanDi;
};

const SET_FORM_MODAL = (state, form) => {
  state.form = form;
};

const SET_DS_SO_BI_GIU = (state, dsSoBiGiu) => {
  state.dsSoBiGiu = dsSoBiGiu;
}

const SET_DS_SINH_SO_NOI_BO = (state, getSinhSoNoiBo) => {
  state.getSinhSoNoiBo = getSinhSoNoiBo;
}

const SET_NOT_RELOAD_PAGE = (state, notReloadList) => {
  state.notReloadList = notReloadList;
}

const SET_DONG_CHI_TIET_VAN_BAN = (state, dongChiTietVanBan) => {
  state.dongChiTietVanBan = dongChiTietVanBan;
}
const SET_VAN_BAN_DEN_DU_THAO = (state, vanBanDenDuThao) => {
  state.vanBanDenDuThao = vanBanDenDuThao;
}
const SET_IS_CA_NHAN = (state, isCaNhan) => {
  state.isCaNhan = isCaNhan;
}

export default {
  SET_VAN_BAN_DEN_DU_THAO,
  SET_DONG_CHI_TIET_VAN_BAN,
  SET_NOT_RELOAD_PAGE,
  SET_DS_SO_BI_GIU,
  SET_FORM_MODAL,
  SET_DOWNLOAD_FILE_DINH_KEM,
  SET_DV_DA_BAN_HANH,
  SET_LICH_SU_THEO_DOI_VB,
  SET_NGUOI_XU_LY_TIEP_THEO,
  SET_CON_VI_NGANG_CAP,
  SET_LS_CAP_NHAT,
  SET_LS_TRA_LAI,
  SET_LS_THU_HOI,
  SET_DANH_SACH_VAN_BAN_DI,
  SET_SO_LUONG_VAN_BAN_DI,
  SET_CHI_TIET_VAN_BAN_DI,
  SET_VAN_BAN_DEN_VAN_BAN_DI,
  SET_MULTI_VAN_BAN_DEN,
  SET_LIST_XIN_SO,
  SET_DANH_SACH_NGUOI_DUOC_TRA_LAI,
  SET_DON_VI_DA_BAN_HANH,
  SET_LS_HUY_DUYET,
  SET_LUONG_XU_LY,
  SET_LICH_SU_KY_DUYET,
  SET_DANH_SACH_MULTI_VAN_BAN_DI,
  SET_LICH_SU_THEO_DOI_LIEN_THONG,
  SET_DS_SINH_SO_NOI_BO,
  SET_IS_CA_NHAN
};
